import React from 'react';
import { Card } from 'react-bootstrap';
import { Link } from 'react-router-dom';
import { FaCalendarAlt, FaUser, FaTag, FaArrowRight } from 'react-icons/fa';

const BlogCard = ({
    blog,
    featured = false,
    showExcerpt = true,
    className = "",
    variant = "default" // "default", "horizontal", "minimal"
}) => {
    if (!blog) return null;

    // Kategori renkleri (OtoSOR benzeri)
    const getCategoryColor = (category) => {
        const colors = {
            'otomobil-dunyasi': '#000000', // Siyah yapıldı
            'arac-bakimi': '#28a745',
            'otomobil-sozlugu': '#ffc107',
            'dunden-bugune': '#6f42c1',
            'finansman-ipuclari': '#20c997',
            'satış-tavsiyeleri': '#fd7e14',
            'sektor-haberleri': '#dc3545'
        };
        return colors[category] || '#6c757d';
    };

    //blog tarih
    const formatDate = (dateString) => {
        if (!dateString) return 'Tarih belirtilmemiş';

        const date = new Date(dateString);
        if (isNaN(date.getTime())) {
            return 'Geçersiz tarih';
        }

        return date.toLocaleDateString('tr-TR', {
            year: 'numeric',
            month: 'long',
            day: 'numeric'
        });
    };

    // Excerpt'i kısalt
    const truncateText = (text, maxLength = 150) => {
        if (!text || text.length <= maxLength) return text;
        return text.substring(0, maxLength).trim() + '...';
    };

    // Variant: Horizontal Layout - Featured Overlay Style
    if (variant === "horizontal") {
        return (
            <div className={`featured-blog-card ${className}`}>
                <div className="featured-blog-image-container">
                    {blog.featuredImage?.url ? (
                        <img
                            src={blog.featuredImage.url}
                            alt={blog.featuredImage.alt || blog.title}
                            className="featured-blog-image"
                        />
                    ) : (
                        <div className="blog-card-no-image">
                            <FaTag size={40} />
                        </div>
                    )}

                    <div className="featured-blog-overlay">
                        <span className="featured-blog-category">
                            {blog.categoryName || blog.category}
                        </span>
                        <h3 className="featured-blog-title">
                            <Link to={`/blog/${blog.slug}`} className="text-white text-decoration-none">
                                {blog.title}
                            </Link>
                        </h3>
                        <div className="featured-blog-meta">
                            <span><FaCalendarAlt className="me-1" />{formatDate(blog.publishedAt || blog.createdAt)
}</span>
                            {blog.author && (
                                <span><FaUser className="me-1" />{blog.authorName || `${blog.author.firstName} ${blog.author.lastName}`}</span>
                            )}
                        </div>
                    </div>
                </div>
            </div>
        );
    }

    // Variant: Minimal Layout  
    if (variant === "minimal") {
        return (
            <div className={`blog-card-minimal ${className}`}>
                <div className="d-flex align-items-start">
                    {blog.featuredImage?.url && (
                        <div className="blog-minimal-image me-3">
                            <img
                                src={blog.featuredImage.url}
                                alt={blog.featuredImage.alt || blog.title}
                                className="rounded"
                            />
                        </div>
                    )}
                    <div className="flex-grow-1">
                        <h6 className="blog-minimal-title mb-1">
                            <Link
                                to={`/blog/${blog.slug}`}
                                className="text-decoration-none"
                            >
                                {blog.title}
                            </Link>
                        </h6>
                        <small className="text-muted">
                            <FaCalendarAlt className="me-1" />
                            {formatDate(blog.publishedAt || blog.createdAt)
}
                        </small>
                    </div>
                </div>
            </div>
        );
    }

    // Default: Vertical Card Layout (OtoSOR benzeri)
    return (
        <div className={`premium-blog-card ${className}`}>
            {/* Resim */}
            <div className="premium-blog-image-container">
                {blog.featuredImage?.url ? (
                    <img
                        src={blog.featuredImage.url}
                        alt={blog.featuredImage.alt || blog.title}
                        className="premium-blog-image"
                    />
                ) : (
                    <div className="blog-card-no-image d-flex flex-column align-items-center justify-content-center">
                        <FaTag size={40} className="text-muted mb-2" />
                        <small className="text-muted">Görsel Yok</small>
                    </div>
                )}
            </div>

            {/* İçerik */}
            <div className="premium-blog-content">
                {/* Kategori */}
                <span className="premium-blog-category-small">
                    {blog.categoryName || blog.category}
                </span>

                {/* Başlık */}
                <h4 className="premium-blog-title">
                    <Link to={`/blog/${blog.slug}`} className="text-decoration-none text-dark">
                        {blog.title}
                    </Link>
                </h4>

                {/* Excerpt */}
                {showExcerpt && blog.excerpt && (
                    <p className="premium-blog-excerpt">
                        {truncateText(blog.excerpt)}
                    </p>
                )}

            
                {/* Meta - OtoSOR Style */}
                <div className="premium-blog-meta">
                    <div className="d-flex justify-content-between align-items-center">
                        <small className="text-muted">
                            {formatDate(blog.publishedAt || blog.createdAt)} • {blog.categoryName || blog.category}
                        </small>
                        <Link to={`/blog/${blog.slug}`} className="text-dark">
                            <FaArrowRight />
                        </Link>
                    </div>
                </div>
            </div>
        </div>

    );
};

export default BlogCard;